import { ApolloError } from '@apollo/client';
import { SaveQuantityReportingConfigError } from '@bechtel/types';

export enum SaveQuantityReportingConfigErrorExt {
  WEEK_START_END_DAY_EQUAL = 'WEEK_START_END_DAY_EQUAL',
}
export interface SaveQuantityReportingErrorProps {
  saveQtyReportingConfigError: SaveQuantityReportingConfigError | SaveQuantityReportingConfigErrorExt | ApolloError;
  close: () => void;
}
